import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Calculatrice du quart - Calculez un quart du nombre";
const DESCRIPTION =
  "Calculatrice du quart - Calculez un quart du nombre pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "du quart un quart du nombre, calculatrice du quart un quart du nombre, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/quarter-calculator/";
function QuarterCalculator() {
  const [number, setNumber] = useState();
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const [steps, setSteps] = useState("");
  const handleCalculate = () => {
    try {
      if (number) {
        const quarter = parseFloat(number / 4).toFixed(2);
        setResult(quarter);
        setSteps(`Pour calculer un quart du nombre ${number}:
        \n1. Nous divisons le nombre par 4: ${number} ÷ 4 = ${quarter}`);
        setError("");
      } else {
        setError("Veuillez entrer un nombre pour effectuer le calcul!");
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice calcule un quart de n'importe quel nombre. Pour effectuer le calcul, nous appliquons l'équation suivante: un quart du nombre = Nombre / 4.
                </p>
                <p>Pour calculer un quart d'un nombre, suivez les étapes suivantes:</p>
                <ul>
                  <li>Entrez le nombre dont vous souhaitez calculer un quart dans le champ désigné.</li>
                  <li>Cliquez sur le bouton "Calculer".</li>
                </ul>
                <p>
                  Cette calculatrice a été développée pour être facile à utiliser et utile pour les personnes qui ont besoin de calculer rapidement et avec précision un quart d'un nombre.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="ltr">
                  <div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label me-2" htmlFor="number">
                          Entrez le nombre
                        </label>
                      </b>
                      <input
                        id="number"
                        type="number"
                        value={number}
                        onChange={(e) => setNumber(e.target.value)}
                        placeholder="Entrez le nombre"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginRight: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-dark">
                      Erreur : {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className=" text-white">Résultat:</h4>
                      <p className="text-white">{result}</p>
                      <div
                        className="p-3 mb-2 bg-info text-dark"
                        style={{ width: "100%" }}
                      >
                        <h4 style={{ color: "black" }}>Étapes de la solution:</h4>
                        <p
                          className="text-dark"
                          style={{ whiteSpace: "pre-line" }}
                        >
                          {steps}
                        </p>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Calculatrice du quart (1/4)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        <strong>Qu'est-ce que la calculatrice du quart ?</strong>
                        Cet outil calcule le quart (1/4) d'un nombre :
                        résultat = nombre ÷ 4.
                      </p>
                      <p>
                        <strong>Comment utiliser :</strong>
                        Entrez le nombre dans le champ prévu, puis appuyez sur "Calculer".
                      </p>
                      <p>
                        <strong>Exemples :</strong>
                        Utiliser 1/4 des ingrédients d'une recette,
                        partager un montant en quatre parts égales,
                        calculer 25% d'une valeur numérique.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default QuarterCalculator;
